import { useLocale } from '~/lang';
import { useUpdateLocale } from '~/hooks/useUpdateLocale';
import Icon from 'Components/Icon';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

const LanguageSelector = () => {
  const locale = useLocale();
  const { mutate, isPending, showSpinner } = useUpdateLocale();

  const isSelected = (id: string) => id === locale.current;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        disabled={isPending}
        className="tw:inline-flex tw:items-center tw:gap-1 tw:px-1 tw:py-1 tw:text-sm tw:rounded-md tw:outline-none tw:text-gray-500 tw:disabled:opacity-100 tw:hover:bg-inherit tw:active:bg-inherit tw:focus:bg-inherit tw:focus:text-gray-500 tw:hover:text-primary"
      >
        {showSpinner ? (
          <Icon name="progress_activity" className="tw:animate-spin" />
        ) : (
          <>
            {locale.current.toUpperCase()}
            <Icon name="arrow_drop_down" />
          </>
        )}
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {locale.options.map(([id, { name }]) => (
          <DropdownMenuItem
            key={id}
            onClick={() => !isSelected(id) && mutate(id)}
            className="tw:justify-between"
            selected={isSelected(id)}
          >
            {name}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default LanguageSelector;
